import { Service } from '@timing71/common';
import { RaceControlMessage } from '@timing71/common/messages';

import { Client } from './client.js';
import { RACE_CONTROL_MESSAGE, STATE_UPDATE } from './constants.js';
import { createManifest, getState } from './translate.js';

export class ITSLive extends Service {

  start(connectionService) {
    const match = ITSLive.regex.exec(this.service.source);

    this._client = new Client(match.groups);

    this._client.on(
      RACE_CONTROL_MESSAGE,
      (msg) => {
        this.onStateChange({
          extraMessages: [
            new RaceControlMessage(msg.message, msg.timestamp).toCTDFormat()
          ]
        });
      }
    );

    this._client.on(
      STATE_UPDATE,
      (state) => {
        this.onManifestChange(createManifest(state));
        this.onStateChange(getState(state));
      }
    );

    this._client.start(connectionService);
  }

  stop() {
    this._client?.stop();
  }

}


// Ick!
// We're looking for at minimum:
// https://www.its-live.net/#/live/<series>
// then optionally subsequent to that:
// https://www.its-live.net/#/live/<series>/<season>/<eventID>/<sessionID>
// but obviously you can't have a session ID without the season and event ID first.
ITSLive.regex = /www.its-live.net\/#\/live\/(?<series>[a-zA-Z0-9]+)(\/(?<season>[0-9]+)(\/(?<eventID>[a-zA-Z0-9]+)(\/(?<sessionID>[0-9]+))?)?)?/;
